var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var FollowUp = /** @class */ (function (_super) {
    __extends(FollowUp, _super);
    function FollowUp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FollowUp.prototype.getId = function () {
        return Number(this.id);
    };
    FollowUp.prototype.getName = function () {
        return this.name;
    };
    FollowUp.prototype.setName = function (name) {
        this.name = name;
    };
    FollowUp.prototype.getResult = function () {
        return this.result;
    };
    FollowUp.prototype.setResult = function (result) {
        this.result = result;
    };
    FollowUp.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    FollowUp.prototype.setPatientId = function (patientId) {
        this.patient_id = patientId;
    };
    FollowUp.prototype.getAppointmentId = function () {
        return Number(this.appointment_id);
    };
    FollowUp.prototype.setAppointmentId = function (appointmentId) {
        this.appointment_id = appointmentId;
    };
    FollowUp.prototype.getCreatedAt = function () {
        if (!this.created_at)
            return '';
        return this.dateFormatter(new Date(this.created_at), 'D MMM YYYY, hh:mm A');
    };
    return FollowUp;
}(Model));
export default FollowUp;
